import { createContext } from 'use-context-selector'
import { OrganizationCreationContextProps } from './types'

export const OrganizationCreationContext = createContext(
  {} as OrganizationCreationContextProps
)
